import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomerApi } from 'app/shared/api/customer.api';
import { CustomerById, CustomerList } from 'app/shared/models/customer.models';

@Component({
  selector: 'customer-search',
  templateUrl: './customer-search.component.html'
})
export class CustomerSearchComponentV2 implements OnInit {
  @Output() customer = new EventEmitter<CustomerById>();

  api = new CustomerApi(this.http);
  shownCustomers: Array<CustomerList>;

  // customer search settings
  customerSearchString: string = '';
  searchAmount: number = 60;
  start: number = 0;
  end: number = 30;
  searched: boolean = false;

  // infinite Scroll Settings
  scrollDistance = 1;
  scrollUpDistance = 2;
  throttle = 150;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }

  getCustomers(start: number, end: number) {
    this.api.getCustomersPagination(start, end).subscribe({
      next: (data: CustomerList[]) => {
        this.shownCustomers = data.sort((a,b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
      }
    })
  }

  searching(event) {
    if (!!this.customerSearchString && this.customerSearchString.length > 2) this.searchCustomers()
    else if (!this.customerSearchString && !!this.searched) {

    }
  }

  searchCustomers() {
    if (!!this.customerSearchString) {
      this.api.searchCustomer(this.customerSearchString, this.searchAmount).subscribe({
        next: (data: CustomerList[]) => {
          this.shownCustomers = data.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
        }
      });
    } else {
      this.start = 0;
      this.end = 30;
      this.getCustomers(this.start, this.end)
    }
  }

  chooseCustomer(customer: CustomerList) {
    this.api.getCustomerById(customer.customerId).subscribe({
      next: (c: CustomerById) => this.customer.emit(c)
    })

  }

  onScrollDown() {
    if (!this.customerSearchString) {
      this.start += 25;
      this.end += 25;
      this.getCustomers(this.start, this.end)
    }
    else {
      this.searchAmount += 25;
      this.searchCustomers()
    }
  }

  trackById(item) {
    return item.id
  }
}
